import type { Analytics } from "../api";

export type HomeAnalyticsState = {
  requestId: number;
  status: "idle" | "loading" | "success" | "error";
  data: Analytics | null;
};

export type HomeAnalyticsAction =
  | { type: "start"; requestId: number }
  | { type: "success"; requestId: number; data: Analytics }
  | { type: "failure"; requestId: number }
  | { type: "reset" };

export const initialHomeAnalyticsState: HomeAnalyticsState = {
  requestId: 0,
  status: "idle",
  data: null,
};

/** Keeps old branch responses from overwriting the currently selected branch. */
export function homeAnalyticsReducer(
  state: HomeAnalyticsState,
  action: HomeAnalyticsAction,
): HomeAnalyticsState {
  if (action.type === "reset") return initialHomeAnalyticsState;
  if (action.type === "start") {
    return { requestId: action.requestId, status: "loading", data: null };
  }
  if (action.requestId !== state.requestId) return state;
  if (action.type === "success") {
    return { ...state, status: "success", data: action.data };
  }
  return { ...state, status: "error", data: null };
}
